webpackJsonp([263791100135453],{

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _navbar = __webpack_require__(9);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _layout = __webpack_require__(10);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _para = __webpack_require__(12);
	
	var _para2 = _interopRequireDefault(_para);
	
	var _para3 = __webpack_require__(13);
	
	var _para4 = _interopRequireDefault(_para3);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _superheader = __webpack_require__(16);
	
	var _superheader2 = _interopRequireDefault(_superheader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Mission = function (_React$Component) {
	  _inherits(Mission, _React$Component);
	
	  function Mission() {
	    _classCallCheck(this, Mission);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Mission.prototype.render = function render() {
	    return _react2.default.createElement(
	      _layout2.default,
	      { key: 'main-layout' },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Surebro: We love solving problems'
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: 'We are a group of problem solvers based in Bangkok' }),
	        _react2.default.createElement('meta', { property: 'og:url', content: 'https://surebro.com/about' }),
	        _react2.default.createElement('meta', { property: 'og:title', content: 'Surebro: We love solving problems' }),
	        _react2.default.createElement('meta', { property: 'og:description', content: 'We are a group of problem solvers based in Bangkok' }),
	        _react2.default.createElement('meta', { property: 'og:image', content: 'https://res.cloudinary.com/surebro/image/upload/v1530280290/Social-share-cover_t18uos.png' })
	      ),
	      _react2.default.createElement(_navbar2.default, { key: 'navbar', active: 0, className: 'blue' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'container About' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'About-header', style: { backgroundImage: 'url(https://res.cloudinary.com/surebro/image/upload/q_auto/v3-static/bangkok.7fee2f59.jpg)' } },
	            _react2.default.createElement(_superheader2.default, {
	              key: 'bkk-title',
	              className: 'white About-header-text',
	              text: 'Bangkok'
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'About-header-image-credit' },
	              _react2.default.createElement(
	                'label',
	                { className: 'About-header-image-credit-label' },
	                'Photo By'
	              ),
	              _react2.default.createElement(
	                'a',
	                { style: {
	                    backgroundColor: 'black',
	                    color: 'white',
	                    textDecoration: 'none',
	                    padding: '4px 6px',
	                    fontSize: '12px',
	                    fontWeight: 'bold',
	                    lineHeight: '1.2',
	                    display: 'inline-block',
	                    borderRadius: '3px'
	                  }, href: 'http://unsplash.com/@sveninho?utm_campaign=photographer-credit', target: '_blank', rel: 'noopener noreferrer' },
	                _react2.default.createElement(
	                  'span',
	                  { style: { display: 'inline-block', padding: '2px 3px' } },
	                  'Sven Scheuermeier'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'div',
	          { className: 'About-content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(_header2.default, {
	              key: 'about-title',
	              className: 'text-left darkgrey About-content-title',
	              text: 'We are a group of problem solvers based in Bangkok'
	            })
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(_para2.default, {
	              key: 'about-1',
	              className: 'text-left grey',
	              text: 'Surebro was built as a platform for me to find problems so I could solve them while I learn about new tech. It\u2019s a win-win because I get to try out new technologies and people get their problems solved. I would release whatever I built for free.'
	            }),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_para2.default, {
	              key: 'about-2',
	              className: 'text-left grey',
	              text: 'I have learnt more than I expected to. Surebro helped me keep up with the crazy pace Software Industry works at but it also helped me learn other things, like what questions to ask to really understand a problem.'
	            }),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_para2.default, {
	              key: 'about-3',
	              className: 'text-left grey',
	              text: 'I have also met a lot of people through Surebro and some ended up joining me. We all are crazy into startups,  building products and growth.'
	            }),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_para2.default, {
	              key: 'about-5',
	              className: 'text-left grey',
	              text: 'The next logical step was to somehow start earning so we could continue building products for free. We tried ads but that just felt wrong. We all had pretty bad experiences with outsourcing firms and realised it didn\u2019t have to be that way. We decided to build an outsourcing firm that worked how we expected them to work.'
	            }),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_para2.default, {
	              key: 'about-6',
	              className: 'text-left grey',
	              text: 'We started accepting projects from Businesses. This has been an incredible learning experience and we love it. It also allows us to spend some of our time working on problems posted on Surebro without having to worry about....food.'
	            }),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_para2.default, {
	              key: 'about-7',
	              className: 'text-left grey',
	              text: 'The more we\'ve worked the more we realise the issue with outsourcing firms. In my opinion, the major issue with outsourcing firms is they accept too many projects because they are competing on prices. They play the volume trick. Unfortunately, quality takes a hit. Nobody can work on 10 projects simultaneously and deliver exceptional products. This is why we only work on 1 project at a time.'
	            }),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_para2.default, {
	              key: 'about-8',
	              className: 'text-left grey',
	              text: 'This has worked quite well for us & our clients. The only problem is we have to say quite a lot of No(s) to quite a lot of interesting projects. We are working on it. Right now, we are happy building one delightful product at a time.'
	            }),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('hr', { style: { width: '100%', borderStyle: 'dashed', borderWidth: '2px', borderColor: "#e3e2e1" } }),
	            _react2.default.createElement(
	              'i',
	              null,
	              _react2.default.createElement(_para4.default, {
	                key: 'author',
	                className: 'text-left light grey',
	                text: 'Chalamphong Pandey (Founder)'
	              })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Mission;
	}(_react2.default.Component);
	
	exports.default = Mission;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-91db511f6644e9adc526.js